import {BaseUser} from "../../../shared/model";

export class AuthUserModel extends BaseUser {
  declare id: number|string;
  center?: {id: string, name: string}

}
